import { FC, ReactNode } from 'react';
import clsx from 'clsx';
import { Box } from '../Box';

import styles from './index.module.css';

interface ClassNames {
  cardClass?: string;
  headerClass?: string;
  contentClass?: string;
  footerClass?: string;
}

interface DataCardProps {
  className?: string;
  commonStyle?: string;
  classNames?: ClassNames;
  header?: ReactNode;
  content?: ReactNode;
  footer?: ReactNode;
  children?: ReactNode;
  onClick?: () => void;
  dataRole?: string;
}

export const DataCard: FC<DataCardProps> = ({
  className = '',
  commonStyle = '',
  classNames = {},
  header,
  content,
  footer,
  children,
  onClick,
  dataRole
}) => {
  const {
    cardClass = '',
    headerClass = '',
    contentClass = '',
    footerClass = ''
  } = classNames;

  return (
    <Box
      className={clsx(styles.card, commonStyle, className, cardClass)}
      direction="column"
      onClick={onClick}
      data-role={dataRole}
    >
      {children}
      {header && (
        <Box
          justify="between"
          align="center"
          padding="s"
          className={clsx(styles.header, commonStyle, headerClass)}
        >
          {header}
        </Box>
      )}
      {content && (
        <Box
          justify="between"
          align="center"
          padding="s"
          className={clsx(styles.content, commonStyle, contentClass)}
        >
          {content}
        </Box>
      )}
      {footer && (
        <Box
          justify="between"
          align="center"
          padding="s"
          className={clsx(styles.footer, commonStyle, footerClass)}
        >
          {footer}
        </Box>
      )}
    </Box>
  );
};
